var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatsapLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#228B22",
    fillRule: "evenodd",
    d: "m0 14.5.985-3.595a6.925 6.925 0 0 1-.927-3.468A6.948 6.948 0 0 1 6.998.5c1.856 0 3.599.723 4.909 2.035a6.894 6.894 0 0 1 2.03 4.908c-.001 3.824-3.114 6.937-6.94 6.937h-.002a6.935 6.935 0 0 1-3.316-.845L0 14.5ZM4.873 4.237c.124.005.26.011.39.3.089.197.238.564.357.857.088.217.16.393.178.43.043.087.072.188.014.304a5.94 5.94 0 0 0-.025.05c-.043.088-.074.153-.148.239-.03.034-.06.071-.09.108-.06.072-.119.144-.17.196-.087.086-.178.18-.076.353.101.174.449.741.964 1.201a4.48 4.48 0 0 0 1.28.81c.048.02.087.036.115.05.173.087.274.073.375-.043.102-.116.434-.506.55-.68.115-.173.23-.144.39-.087.158.058 1.01.478 1.184.565l.096.046c.12.058.202.098.237.156.043.072.043.42-.101.824-.145.405-.853.796-1.17.825-.031.002-.062.006-.093.01-.294.034-.665.078-1.988-.444-1.63-.643-2.705-2.237-2.926-2.564l-.036-.054-.003-.002c-.093-.126-.705-.944-.705-1.79 0-.799.392-1.217.572-1.41l.035-.037a.637.637 0 0 1 .462-.217l.332.004Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatsapLogo);
export default __webpack_public_path__ + "static/media/watsapLogo.03773b8df25218f421c8e532b4fb65f9.svg";
export { ForwardRef as ReactComponent };